import * as React from "react";

import { Resources, useResource } from "Translations/Resources";
import { booleanListItems } from "Utils/FilterUtils";
import { AccessRightCodes } from "Components/Models/AccessRights";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { BreadcrumbItem } from "Components/Layout/Breadcrumbs";
import {
  EmployeeListDto,
  FilterPropsEmployee,
  postHumanResourceGetEmployeeList,
} from "Api/Api";
import { CookieNames } from "Components/Models/CookieNames";
import { useTableFiltration } from "Hooks/Tables/useTableFiltration";
import { booleanValueMapper } from "Utils/FilterUtils";
import { EmployeesTable } from "Components/HumanResources/Employees/EmployeesList/EmployeesTable";
import { useState } from "react";

type State = {
  employees: EmployeeListDto[];
  isLoading: boolean;
  totalCount: number;
};

export const EmployeesPage: React.FunctionComponent = _ => {
  const { t } = useResource();
  const [state, setState] = useState<State>({
    employees: [],
    isLoading: true,
    totalCount: 0,
  });

  const [filtration] = useTableFiltration<EmployeeListDto, FilterPropsEmployee>(
    {
      tableCode: CookieNames.ExternalEmployees,
      onDataLoad: filter => {
        setState({
          ...state,
          isLoading: true,
        });

        postHumanResourceGetEmployeeList({
          ...filter,
          limit: filter.rows,
          offset: filter.page * filter.rows,
        }).then(result => {
          setState({
            isLoading: false,
            employees: result.json.items,
            totalCount: result.json.totalCount,
          });
        });
      },
      defaultOrderBy: "name",
      filters: [
        {
          propertyName: "name",
          defaultValue: "",
        },
        {
          propertyName: "positionName",
          defaultValue: "",
        },
        {
          propertyName: "departmentNames",
          defaultValue: "",
        },
        {
          propertyName: "contactPersonName",
          defaultValue: "",
        },
        {
          propertyName: "isActive",
          defaultValue: "true",
          valueMapper: booleanValueMapper,
          listItems: booleanListItems,
        },
        {
          propertyName: "updatedByUserName",
          defaultValue: "",
        },
      ],
    },
  );

  return (
    <AuthenticatedLayout
      title="Kontakty"
      create={{
        accessRightCodes: [
          AccessRightCodes.Core_HumanResources_ExternalSuppliers_Edit,
        ],
        url: `/${t(Resources.Routes.Employees)}/${t(
          Resources.Routes.EmployeeCreate,
        )}`,
        title: "Nový kontakt",
      }}
      breadcrumbItems={[
        {
          name: "Přehled kontaktů",
        } as BreadcrumbItem,
      ]}
    >
      <EmployeesTable
        employees={state.employees}
        totalCount={state.totalCount}
        onPageChange={filtration.onPageChange}
        isLoading={state.isLoading}
        filter={filtration.getFilterProps()}
        orderBy={filtration.ordering}
        paginationParams={filtration.pagination}
      />
    </AuthenticatedLayout>
  );
};
